import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-page-clean-white',
    templateUrl: './page-clean-white.component.html',
    styleUrls: ['./page-clean-white.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PageCleanWhiteComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
